export default "__VITE_ASSET__6184c5be__"